/* global angular */

var ngModule = angular.module('trends');

ngModule.config(['$interpolateProvider', '$httpProvider',
    function ($interpolateProvider, $httpProvider) {
        // Django compatibility
        $interpolateProvider.startSymbol('{$');
        $interpolateProvider.endSymbol('$}');
        $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHTTPRequest';
    }]);

ngModule.config(['$stateProvider', '$urlRouterProvider',
    function ($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/');

        // Note: when adding a templateUrl, ensure that it's not a redirect but the full URL
        $stateProvider
            .state('homepage', {
                url: '/',
                controller: 'HomepageController',
                templateUrl: '/trends/partials/homepage/',
                noAnalyticsPageview: true
            })
            .state('trend', {
                url: '/trend/:item_id',
                templateUrl: function ($stateParams) {
                    return '/trends/partials/trend/' + $stateParams.item_id + '/';
                }
            })
            .state('observation', {
                url: '/observation/:item_id',
                templateUrl: function ($stateParams) {
                    return '/trends/partials/observation/' + $stateParams.item_id + '/';
                }
            })
            .state('group', {
                url: '/group/:hvt_id',
                templateUrl: function ($stateParams) {
                    return '/trends/partials/group/' + $stateParams.hvt_id + '/';
                }
            })
            .state('trendscape-item', {
                url: '/trendscape/item/{item_type}/{item_id}',
                templateUrl: function ($stateParams) {
                    return '/trends/partials/trendscape/item/' + $stateParams.item_type + '/' +
                        $stateParams.item_id + '/';
                }
            })
            .state('trendscape-search', {
                url: '/trendscape/search/?q&filters',
                templateUrl: function ($stateParams) {
                    return '/trends/partials/trendscape/search/?q=' + $stateParams.q +
                        ($stateParams.filters ? '&filters=' + $stateParams.filters : '');
                }
            })
            .state('search', {
                url: '/search?q&filters&focus',
                templateUrl: function ($stateParams) {
                    return '/trends/partials/search/?' +
                        ($stateParams.q ? 'q=' + $stateParams.q : '') +
                        ($stateParams.filters ? '&filters=' + $stateParams.filters: '') +
                        ($stateParams.focus ? '&focus=' + $stateParams.focus : '');
                },
                reloadOnSearch: false,
                noAnalyticsPageview: true
            })
            .state('logged-off', {
                url: '/logged_off',
                templateUrl: function () {
                    return '/trends/partials/logged_off/';
                }
            });
    }]);
